import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogIndex from "../pages/blog/index";
import Article1 from "../pages/blog/wall-mounted-tvs-vs-entertainment-units";
import Article2 from "../pages/blog/minimalist-setup-wall-mounted-screen";
import Article3 from "../pages/blog/tv-placement-comfort-viewing-experience";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogIndex />,
  },
  {
    path: "/blog/wall-mounted-tvs-vs-entertainment-units",
    element: <Article1 />,
  },
  {
    path: "/blog/minimalist-setup-wall-mounted-screen",
    element: <Article2 />,
  },
  {
    path: "/blog/tv-placement-comfort-viewing-experience",
    element: <Article3 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
